var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEuxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 32,
    viewBox: "0 0 105 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1149 0V19.9416C45.1149 23.6982 42.059 26.7541 38.3029 26.7541C34.5462 26.7541 31.4904 23.6982 31.4904 19.9416V0H26.2444V19.9416C26.2444 26.5907 31.6538 32 38.3029 32C44.9515 32 50.3608 26.5907 50.3608 19.9416V0H45.1149Z",
    className: "svg-logo-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4264 2.28882e-05H80.787V15.7378H86.033V5.24593H94.4264C97.319 5.24593 99.6723 7.5993 99.6723 10.4918C99.6723 13.3844 97.319 15.7378 94.4264 15.7378H86.033L80.787 20.9837V31.4755H86.033V20.9837H94.4264C100.212 20.9837 104.918 16.2771 104.918 10.4918C104.918 4.70662 100.212 2.28882e-05 94.4264 2.28882e-05Z",
    className: "svg-logo-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3444 2.28882e-05L62.4264 15.7378L71.3444 31.4755H77.6395L68.7215 15.7378L77.6395 2.28882e-05H71.3444Z",
    className: "svg-logo-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8034 31.4755L68.7214 15.7378L59.8034 2.28882e-05H53.5083L62.4264 15.7378L53.5083 31.4755H59.8034Z",
    className: "svg-logo-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5188 5.24591V0.0211963H5.22472V0H0V0.0211963V5.24591V13.1563V18.381V26.2333H5.22472L0.0105661 31.4581H5.22472H21.5188V26.2333H5.22472V18.381H18.9065V13.1563H5.22472V5.24591H21.5188Z",
    className: "svg-logo-1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.918,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEuxp);
export default __webpack_public_path__ + "static/media/logo-euxp.0b2a9abf6606267fdbdec4c08bacec03.svg";
export { ForwardRef as ReactComponent };